import { render, staticRenderFns } from "./platformList.vue?vue&type=template&id=f1e0baa0"
import script from "./platformList.vue?vue&type=script&lang=js"
export * from "./platformList.vue?vue&type=script&lang=js"
import style0 from "./platformList.vue?vue&type=style&index=0&id=f1e0baa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports